import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Trash2, Calendar } from 'lucide-react';
import RichTextEditor from '../RichTextEditor';
import DOMPurify from 'dompurify';

const NoteComments = ({
  comments,
  newCommentContent,
  setNewCommentContent,
  onAddComment,
  onDeleteComment,
  isEditing,
  editingCommentId,
  editCommentContent,
  setEditCommentContent,
  onEditComment,
  onCancelEdit,
  onStartEdit
}) => {
  return (
    <div className="mt-4 pt-4 border-t space-y-4">
      {/* Add comment form */}
      <div>
        <RichTextEditor
          value={newCommentContent}
          onChange={setNewCommentContent}
          placeholder="Ajouter un commentaire..."
        />
        <Button 
          onClick={onAddComment}
          className="mt-2"
          disabled={!newCommentContent || newCommentContent === '<p><br></p>'}
        >
          Ajouter le commentaire
        </Button>
      </div>

      {/* Comments list */}
      {comments && comments.length > 0 ? (
        <div className="space-y-3">
          {comments.map(comment => (
            <Card key={comment.id} className="bg-gray-50">
              <CardContent className="p-3">
                {isEditing && editingCommentId === comment.id ? (
                  <div>
                    <RichTextEditor
                      value={editCommentContent}
                      onChange={setEditCommentContent}
                      placeholder="Modifier le commentaire..."
                    />
                    <div className="flex gap-2 mt-2">
                      <Button size="sm" onClick={() => onEditComment(comment.id)}>
                        Sauvegarder
                      </Button>
                      <Button size="sm" variant="outline" onClick={onCancelEdit}>
                        Annuler
                      </Button>
                    </div>
                  </div>
                ) : (
                  <>
                    <div 
                      className="prose prose-sm max-w-none text-gray-700"
                      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(comment.content) }}
                    />
                    <div className="flex items-center justify-between mt-2 pt-2 border-t border-gray-200 text-xs text-gray-500">
                      <div className="flex items-center gap-1">
                        <Calendar className="h-3 w-3" />
                        {new Date(comment.created_at).toLocaleDateString('fr-FR', {
                          day: 'numeric',
                          month: 'short',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit'
                        })}
                        {comment.author_name && (
                          <span className="ml-2 font-medium">{comment.author_name}</span>
                        )}
                      </div>
                      <div className="flex gap-1">
                        <Button
                          variant="ghost"
                          size="sm"
                          className="h-6 px-2 text-xs"
                          onClick={() => onStartEdit(comment)}
                        >
                          Modifier
                        </Button>
                        <Button
                          variant="ghost"
                          size="sm"
                          className="h-6 px-2 text-xs text-red-500 hover:text-red-700"
                          onClick={() => onDeleteComment(comment.id)}
                        >
                          <Trash2 className="h-3 w-3" />
                        </Button>
                      </div>
                    </div>
                  </>
                )}
              </CardContent>
            </Card>
          ))}
        </div>
      ) : (
        <p className="text-sm text-gray-500 text-center py-2">
          Aucun commentaire pour cette note
        </p>
      )}
    </div>
  );
};

export default NoteComments;
